<template>
    <div class="campus-box">

        <img src="@/pc/images/campus-bg.png" class="campus-bg">
        <div class="campus-con">
            <Row>
                <Col span="6">
                    <ul class="camplus-left">
                        <li :class="{on: nowType === ''}" @click="setType('')">
                            <div>
                                <span>全部</span>
                                <Icon type="ios-arrow-forward"/>
                            </div>
                        </li>
                        <li  v-for="(type,i) in types" :key="i" :class="{on: nowType === type.id}" @click="setType(type.id)">
                            <div>
                                <span>{{type.tag_name}}</span>
                                <Icon type="ios-arrow-forward"/>
                            </div>
                        </li>
                    </ul>
                </Col>
                <Col span="18">
                    <div class="camplus-right">
                        <div class="camplus-city">
                            <span>工作城市：</span>
                             <span :class="{on: nowCity === ''}" @click="setCity('')">全部</span>
                            <span  v-for="(city,i) in citys" :key="i" :class="{on: nowCity === city.id}" @click="setCity(city.id)">{{city.tag_name}}</span>
                        </div>
                        <div class="camplus-search">
                             <Row>
                                <Col span="6">
                                    <Input type="text" icon="ios-search" v-model="nowKey" @on-click = 'search' @on-enter="search" placeholder="请输入职位关键词"  width="100%"/>
                                </Col>
                                <Col span="5" offset="13" class="camplus-postnum">共{{total}}个职位</Col>
                            </Row>
                        </div>
                        <ul class="post-list">
                                <li v-for="(work,i) in works" :key="i">
                                    <router-link :to="{name:'cdetail',params:{entry_id: $route.params.entry_id,id: work.id}}" >
                                    <p class="post-title">
                                        {{work.job_name}}
                                        <span>{{work.salary}}</span>
                                    </p>
                                    <p class="need">
                                        <em v-for="place in work.job_places">
                                            {{place}}
                                        </em>
                                        <span>|</span>
                                         {{work.edu}}
                                        <span class="time">发布于{{work.update_at}}</span>
                                    </p>
                                    </router-link>
                                </li>

                        </ul>
                        <Page v-if="total > 10" :current="nowPage"  :page-size="10" :total="total" class-name="pagenation" @on-change="getPage"/>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                citys:[],
                types:[],
                works:{},
                nowPage:1,
                nowCity: '',
                nowType: '',
                nowKey: '',
                total:''
            }
        },
        methods: {
            getLabelList() {
                this.$axios.get(this.api.getLabelList,{
                    params: { entry_id: this.$route.params.entry_id || 0 }
                })
                    .then(res=>{
                        this.citys = res.data.citys;
                        this.types = res.data.types;
                    })
            },
            getData(){
                this.$axios.get(this.api.getCampusData,{
                    params: {
                        pageSize: 10,
                        page: this.nowPage,
                        city: this.nowCity,
                        type: this.nowType,
                        key: this.nowKey,
                        entry_id: this.$route.params.entry_id || 0
                    }
                })
                    .then(res=>{
                        this.works = res.data.data;
                        this.nowPage = res.data.current_page;
                        this.total = res.data.total;
                    })
            },
            getPage(p){
                this.nowPage = p;
                this.getData();
            },
            setCity(city){
                this.nowKey = '';
                this.nowCity = city;
                this.nowPage = 1;
                this.getData();
            },
            setType(type){
                this.nowKey = '';
                this.nowCity = '';
                this.nowType = type;
                this.nowPage = 1;
                this.getData();
            },
            search(){
                if(this.nowKey){
                    this.getData();
                }
            }
        },
        created() {
            this.getLabelList();
            this.getData();

        },
        mounted () {

        }
    }
</script>
<style scoped>
.campus-box{
    min-height: 93.5vh;
    background: #f3f3f3;
    padding-bottom: 80px;
}
.campus-bg{
    width: 100%;
    margin-top: -60px;
}
.campus-con{
    padding: 2vh 17%;
}
.camplus-left{
    background: #fff;
    border-radius: 5px;
}
.camplus-left li{
    color: #359265;
    font-size: .8rem;
    cursor: pointer;
}
.camplus-left li div{
    margin: 0 15px;
    padding: 18px 0;
    border-top:1px dashed #f0f0f0;
}
.camplus-left li div i{
   float: right;
}
.camplus-left li:hover{
    background: #359265;
    color: #fff;
}
 .camplus-left .on{
    background: #359265;

    color: #fff;
}
 .camplus-left .on div{
     border-top:1px solid #359265;
 }
.camplus-left li:hover  div{
        border-top:1px solid #359265;
}
.camplus-left li:first-child{
    border-radius: 5px 5px 0 0;
}
.camplus-left li:first-child div{
    border-top: none;
}
.camplus-left li:last-child{
    border-radius: 0 0 5px 5px;
}
.camplus-right{
    font-size: .8rem;
    margin-left: 20px;
    background: #fff;
    border-radius: 5px;
    padding: 0 20px 10px 20px;
}
.camplus-city{
    padding: 20px 0;
    color: #7f8382;
    border-bottom: 1px solid #f1f1f1;
    line-height: 1.6rem;
}
.camplus-city span{
    margin-right:20px;
    cursor: pointer;
}
.camplus-city span:hover{
    color: #359265;
}
.camplus-city span:first-child{
    color: #3b3e40;
    cursor: auto;
}
.camplus-city span.on{
    color: #359265;
}
.camplus-search{
     padding: 20px 0;
}
.camplus-postnum{
    text-align: right;
}
.post-list{
    border-top: 1px solid #f1f1f1;
}
.post-list li{
    font-family: '微软雅黑';
    border-bottom: 1px solid #f1f1f1;
    padding: 20px 0;
    cursor: pointer;
}
.post-list li:hover .post-title{
    color: #359265;
}
.post-title{
    font-size: 1rem;
}
.post-title span{
    color: #359265;
    float:right;
}
.need{
     color:#7f8382;
    font-size:.8rem;
    padding-top: 5px;
}
.need span{
     color:#d6d6d6;
}
.need .time{
    float:right;
    color:#7f8382;
}
.ivu-page{
    margin: 20px 0;
}
</style>
<style>
.pagenation .ivu-page-item{
    border-radius:50px;
}
.ivu-page-item-jump-prev, .ivu-page-item-jump-next{
    border:none;
}
.ivu-page-next, .ivu-page-prev{
    border:none;
    border-radius:50px;
    background-color: #f7f7fa;
}
</style>

